<template>
  <Scatter
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :height="height"
  />
</template>

<script>
import { Scatter } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  CategoryScale,
  PointElement,
  LinearScale
} from 'chart.js'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  CategoryScale,
  PointElement,
  LinearScale
)

export default {
  name: 'chartPatrimonies',
  props:['data','type','pointData','share'],
  components: {
    Scatter
  },
  data() {
    return {
      chartId:this.type == 'LCOE_POWER'? 'Lcoe_power_chart':  this.type == 'PVREADY_POWER' ? 'PVReady_power_chart':'lcoe_PVReady_chart',
      height : 800,
      graphData:[],
      chartData: {
        datasets: [
          {
            label:this.type == 'LCOE_POWER' ? 'Coût de revient / Puissance': this.type == 'PVREADY_POWER' ? 'Pv_ready / Puissance' : 'Coût de revient / Pv_ready',
            data: [],
            radius:[],
            pointStyle:[],
            borderColor: '#000000',
            backgroundColor:[],
            hoverRadius:10
          }
        ]
      },
    }
  },
  computed:{
    chartOptions() {
      return{
        onClick:this.getClickedPoint,
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
            mode: 'nearest'
        },
        plugins: {
          datalabels: {
              color: 'white',
              display: false,
          },
          legend: {
            display:true,
            labels: {
              color: 'white',
              font:{
                size:20
              }
            },
          },
          tooltip:{
            enabled:true,
            titleAlign:'center',
            titleFont:{
              size:18
            },
            callbacks: {
              title: ((tooltipItems) => {
                return this.data[tooltipItems[0].dataIndex].name
              }),
              label: ((tooltipItems) => {
                return "Coût de revient : " + this.data[tooltipItems.dataIndex].LCOE + " | " +
                      "Puissance : " + this.data[tooltipItems.dataIndex].puissance + " | " +
                      "Coefficient Pv-ready : " + this.data[tooltipItems.dataIndex].PvReady
              })
            }
          }
        },
        scales: {
          x: {
            ticks: {
              color: 'white',    
            },
            grid: {
              color: 'white',
              display: true,
            },
            title: {
              display: true,
              text: this.type == "LCOE_PVREADY" ? 'Coefficient PV Ready':'Puissance',
              color: 'white',
              font: {
                size: 20,
                weight: 'bold',
                lineHeight: 1.2,
              },
              padding: {
                top: 10,
                left: 0,
                right: 0,
                bottom: 0
              },
            },
          },
          y: {
            ticks: {
              color: 'white',
            },
            grid: { 
              color: 'white'
            },
            display: true,
            title: {
              display: true,
              text: this.type == "LCOE_POWER" ? 'Coût de revient [€HT/MWh]': this.type == 'PVREADY_POWER' ?'Coefficient PV Ready':'Coût de revient [€HT/MWh]',
              color: 'white',
              font: {
                size: 20,
                weight: 'bold',
                lineHeight: 1.2,
              },
              padding: {
                top: 10,
                left: 0,
                right: 0,
                bottom: 0
              },
            },               
          },              
        },
      }
    },
  },
  mounted:function(){
    this.graphData = this.data;
    this.fillGraphData();
  },
  methods:{
    /**
     * Récupère les données du point sur lequel on clique
     */
    getClickedPoint(e){
      e.native.preventDefault();
      var point = e.chart.getElementsAtEventForMode(e, 'nearest', { intersect: true }, false);
      if(point.length) {
        var datasetIndex = point[0].datasetIndex;
        var pointIndex = point[0].index;

        //provoque le changement de valeur de la props "share" qui est observée pour modifier la taille du point
        this.$emit('shareRadius',datasetIndex,pointIndex);
      }
    },
    /**
     * Ajoute les données au graphique
     */
    fillGraphData(){

      const DEFAULT_RADIUS = 5;

      var tabAxes = this.defineAxes();
      var absysse = tabAxes['ordonnee'];
      var ordonnee = tabAxes['absysse'];

      var pointData = {};
      this.graphData.forEach(site => {
        pointData.y = site[absysse];
        pointData.x = site[ordonnee];

        this.chartData.datasets[0].data.push(pointData);
        this.chartData.datasets[0].radius.push(DEFAULT_RADIUS);
        this.chartData.datasets[0].pointStyle.push('circle');
        this.chartData.datasets[0].backgroundColor.push('#18FE01');
        pointData={};
      });
    },
    /**
     * Défini les deux axes du graphique en fonction de la props "type" passée en paramètre
     */
    defineAxes(){
      var tabAxes=[];

      switch (this.type) {
        case 'LCOE_POWER':
          tabAxes['ordonnee'] = 'LCOE'
          tabAxes['absysse'] = 'puissance';
          
          break;
        case 'PVREADY_POWER':
          tabAxes['ordonnee'] = 'PvReady'
          tabAxes['absysse'] = 'puissance';
          
          break;
        case 'LCOE_PVREADY':
          tabAxes['ordonnee'] = 'LCOE';
          tabAxes['absysse'] = 'PvReady';
          
          break;
    
        default:
          break;
      }
      return tabAxes;
    },
    /**
     * Modifie les caractéristiques du point dont les index sont passé dans pointData 
     */
    changePoint(pointData){
      const DEFAULT_RADIUS = 5;
      const UPGRADED_RADIUS = 15;

      var datasetIndex = pointData['datasetIndex'];
      var index = pointData['pointIndex'];

      var currentRadius = this.chartData.datasets[datasetIndex].radius[index];
      var newRadius = 0;
      var pointStyle = "";
      var backgroundColor = "";

      //tous les changements sur le point sont basés en fonction de la taille du radius du point
      if (currentRadius==UPGRADED_RADIUS) {
        newRadius = DEFAULT_RADIUS;
        pointStyle ="circle";
        backgroundColor="#18FE01";
      }else{
        newRadius = UPGRADED_RADIUS;
        pointStyle ="rectRot";
        backgroundColor="#ff5dcc";
      }      
      this.chartData.datasets[datasetIndex].radius[index] = newRadius;
      this.chartData.datasets[datasetIndex].pointStyle[index] = pointStyle;
      this.chartData.datasets[datasetIndex].backgroundColor[index] = backgroundColor;
    },
    /**
     * Update les données du graphique manuellement
     */
    updateChartData(){
      var data = this.chartData.datasets;
      this.chartData.datasets = [];
      this.chartData.datasets = data;
    }
  },
  watch: {
    //Props dont le changement de valeur est observé
    share(){
      this.changePoint(this.pointData);
      this.updateChartData();
    }
  }
}
</script>
